/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import dynamic from "next/dynamic";

import Button from "components/Button";

import CloseIcon from "resources/icons/close.svg";

import styles from "./SubprofilesContainer.module.scss";

const HeaderLogo = dynamic(
  () => import("components/AppHeader/components/HeaderLogo")
);

export interface ISubprofilesContainerProps {
  children: JSX.Element;
  close?: () => void;
}

export const SubprofilesContainer = ({
  children,
  close,
}: ISubprofilesContainerProps) => {
  return (
    <div className={styles.subprofilesContainer}>
      <div className={styles.logoContainer}>
        <HeaderLogo />
      </div>
      {close && (
        <Button
          variant="tertiary"
          icon={<CloseIcon />}
          className={styles.close}
          onClick={close}
        />
      )}
      {children}
    </div>
  );
};

export default SubprofilesContainer;
